// @ts-expect-error pnpm issue?
import { animate, scroll } from "motion";
import s from "./style.module.css";
export interface Input {
    scrollTarget: () => HTMLDivElement;
}

<let/reduceMotion=false>
<let/animateWithCSS=true>

<section class=s.section>
    <header/textRef class=s.header>
        <h1 aria-hidden="true">
            eBay Design
        </h1>
        <h2 class=s.text>
            Our purpose is to enable our customers to buy and sell with ease by
            crafting intuitive, delightful experiences.
        </h2>
    </header>
    <script>
        const prm = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        reduceMotion = prm;
        animateWithCSS = CSS.supports("(animation-timeline: scroll())");
        const end = prm ? 0.5 : 0;
        const cancel = scroll(
            animate(
                textRef(),
                {
                    opacity: [1, 1, end, end],
                },
                {
                    ease: "easeOut",
                },
            ),
            {
                target: input.scrollTarget(),
                offset: ["start start", "end start"],
            },
        );
        $signal.onabort = () => cancel();
    </script>
    <if=animateWithCSS || reduceMotion>
        <home-card-stack-sda/>
    </if>
    <else>
        <home-card-stack-sda-fb/>
    </else>
</section>
